import React from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import classNames from 'classnames';
import moment from 'moment';
import { useAppDispatch, useAppSelector } from 'Stores/Hooks/hooks';
import { CampaignState, getCampaignDetailsById } from 'Stores/Slices/campaignSlice';
import { RootState } from 'Stores/store';
const PREFIX = 'ContentStatusDialogBox';

const classes = {
    table: `${PREFIX}-table`
};

const Root = styled('div')({
	[`& .${classes.table}`]: {
		minWidth: 'auto',
	},
});

const ContentStatusDialogBox = (props: any) => {

	const dispatch = useAppDispatch();
	const [open, setOpen] = React.useState(false);
	const rowData = props.rowData;
	const campaignStore: CampaignState = useAppSelector(
		(state: RootState) => state.campaign,
	);
	const { campaign } = campaignStore;

	const handleClickOpen = () => {
		setOpen(true);
		dispatch(getCampaignDetailsById(rowData.id));
	};
	const handleClose = () => {
		setOpen(false);
	};

	const transformStatusToCSSClass = (status: any) => {
		return status.replace(/\s/g, '').toLowerCase();
	};
	return (
        <Root style={{ minWidth: '700px', maxWidth: 'auto' }}>
			<Button
				variant="outlined"
				color="primary"
				onClick={handleClickOpen}
				className={classNames(
					'campaign-status',
					'status-' + transformStatusToCSSClass(rowData.contentStatus),
				)}>
				{rowData.contentStatus}
			</Button>
			<Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
				<DialogTitle id="form-dialog-title">Content Status</DialogTitle>
				<DialogContent>
					<TableContainer component={Paper}>
						<Table className={classes.table} aria-label="simple table">
							<TableHead>
								<TableRow>
									<TableCell>Name</TableCell>
									<TableCell align="center">Start Date</TableCell>
									<TableCell align="center">End Date</TableCell>
									<TableCell align="center">Campaign Cost</TableCell>
									<TableCell align="center">Comments</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{campaign?.campaignAdvertisementDetailsResponse?.map(
									(advertisement: any, index: number) => (
										<TableRow key={index}>
											<TableCell component="th" scope="row">
												{advertisement.advertisementResponse.name}
											</TableCell>
											<TableCell align="center">
												{' '}
												{advertisement.startDate &&
													moment(
														advertisement.startDate,
													).format('YYYY-MM-DD')}
											</TableCell>
											<TableCell align="center">
												{' '}
												{advertisement.endDate &&
													moment(advertisement.endDate).format(
														'YYYY-MM-DD',
													)}
											</TableCell>
											<TableCell align="center">
												{advertisement.calculatedBudget}
											</TableCell>
											<TableCell align="center">
												{advertisement.advertisementResponse
													.advertisementDetailsStatusLogList
													.length > 0
													? advertisement.advertisementResponse
															.advertisementDetailsStatusLogList[0]
															.comments
													: 'no comment avaliable'}
											</TableCell>
										</TableRow>
									),
								)}
							</TableBody>
						</Table>
					</TableContainer>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} color="primary">
						close
					</Button>
				</DialogActions>
			</Dialog>
		</Root>
    );
};

export default ContentStatusDialogBox;
